import { UserPhone } from "../types/user";

export const parsePhone = (phone: string | UserPhone) => {
    try {
        if (!phone) return '';

        if (typeof phone === 'string') {
        return phone.replace(/\s+/g, '');
        }

        if (typeof phone === 'object') {
        const { countryCode, number } = phone;

        if (!countryCode && !number) return '';
        if (!countryCode && number) return number.replace(/\s+/g, '');
        if (countryCode && !number) return '';

        return `${countryCode}${number}`.replace(/\s+/g, '');
        }

        return '';
    } catch (error) {
        console.error('Error for get user full phone by tools:', error);
        return '';
    }
};